import ListaPreciosVentaManagementPage from "../pages/ListaPreciosVentaManagementPage";

const routes = [
  {
    name: "ListaPreciosVentaManagementPage",
    path: "/lista-precios-venta-management",
    component: ListaPreciosVentaManagementPage,
  },
];

export default routes;
